import { z } from "zod";
import { organisationSchema } from "./catalog.js";
import { personaSchema } from "./people.js";

export const demoPersonaSchema = personaSchema.and(
  z.object({
    organisationId: z.string().min(1),
    organisationName: z.string().min(1),
  }),
);

export const demoSessionSelectionSchema = z.object({ personaId: z.string().min(1) }).strict();

export const currentSessionSchema = z.discriminatedUnion("authenticated", [
  z.object({ authenticated: z.literal(false) }),
  z.object({
    authenticated: z.literal(true),
    organisation: organisationSchema,
    persona: personaSchema,
    permissions: z.array(
      z.enum([
        "catalogue:manage",
        "learning:self",
        "organisation:reset",
        "platform:read",
        "settings:manage",
        "supervision:review",
      ]),
    ),
    expiresAt: z.string().datetime(),
  }),
]);

export const sessionMutationResultSchema = z.object({ ok: z.literal(true) });

export type DemoPersona = z.infer<typeof demoPersonaSchema>;
export type DemoSessionSelection = z.infer<typeof demoSessionSelectionSchema>;
export type CurrentSession = z.infer<typeof currentSessionSchema>;
